import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './Login';
import Hello from './Hello';
import SessionDetails from './SessionDetails';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/hello" element={<Hello />} />
          <Route path="/" element={<Login />} />
          <Route path="/session/:sessionId" element={<SessionDetails />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
